import { defineComponent as _defineComponent } from 'vue'
import WujieVue from 'wujie-vue2';
import {
    nextTick, onBeforeUnmount, ref, withDefaults, watch,
} from 'vue';
import type { PatsnapCopilotService } from 'src/patsnap-copilot-service.interface';
import { wujieOptions } from '../copilot';
import { useCopilotUsage } from './composables/use-copilot-usage';


export default /*#__PURE__*/_defineComponent({
  __name: 'PatsnapCopilot',
  props: {
    service: { default: undefined },
    url: null
  },
  setup(__props: any) {

const props = __props as { service: PatsnapCopilotService, url: string }

const { enabled, patsnapCopilotUsage } = useCopilotUsage();



function getOptions() {
    const options = wujieOptions({
        service: props.service,
        url: props.url,
        patsnapCopilotUsage: patsnapCopilotUsage.value,
    });
    return options;
}

const root = ref<HTMLElement | null>(null);

watch(enabled, async (value) => {
    if (value) {
        await nextTick();
        if (root.value) {
            document.body.appendChild(root.value);
        }
    } else {
        await nextTick();
        if (root.value) {
            document.body.removeChild(root.value);
        }
    }
});

onBeforeUnmount(() => {
    if (root.value) {
        document.body.removeChild(root.value);
    }
});

return { __sfc: true,enabled, patsnapCopilotUsage, props, getOptions, root, WujieVue }
}

})